
export * from './scopes.detail.model'
export * from './scopes.export.column.list'
export * from './scopes.list.model'
export * from './edit.update.scopes.model'
export * from './scopes.list.response.model'

